import { Loader2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFetch } from "@/hooks/useFetch";
import { PEOPLE } from "@/lib/spaces";
import { SpaceAvatar } from "@/components/SpaceAvatar";

export const Field = ({ label, children, hint }) => (
  <div className="space-y-2">
    <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</Label>
    {children}
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const SpacePicker = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {PEOPLE.map((p) => (
      <button key={p.key} type="button" data-testid={`space-pick-${p.key}`} onClick={() => onChange(p.key)}
        className="flex items-center gap-2 rounded-full border py-1 pl-1 pr-3 text-sm font-medium transition-colors hover:bg-white/5"
        style={value === p.key ? { borderColor: p.color, background: `${p.color}1a`, color: p.color } : {}}>
        <SpaceAvatar space={p.key} /> {p.name}
      </button>
    ))}
  </div>
);

export const ProjectPicker = ({ value, onChange }) => {
  const projects = useFetch("/projects") || [];
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
      <SelectTrigger data-testid="project-picker"><SelectValue placeholder="No project" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">No project</SelectItem>
        {projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.title}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};

export const SubmitRow = ({ busy, label, onCancel, testid }) => (
  <div className="flex items-center justify-end gap-2 pt-2">
    <button type="button" onClick={onCancel} className="h-10 rounded-full px-5 text-sm font-medium text-muted-foreground transition-colors hover:bg-white/5 hover:text-foreground">Cancel</button>
    <button type="submit" disabled={busy} data-testid={testid} className="flex h-10 items-center gap-2 rounded-full bg-primary px-6 text-sm font-semibold text-primary-foreground transition-colors hover:bg-white disabled:opacity-60">
      {busy && <Loader2 className="h-4 w-4 animate-spin" />} {label}
    </button>
  </div>
);
